import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { BxBreadcrumb, BxButtonComponent } from '@beyonnex/bx-angular-ui';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LocalizationService } from '../../services/localization/localization.service';
import { PageComponent } from '../page/page.component';

@Component({
  selector: 'bxi-settings',
  imports: [PageComponent, TranslatePipe, BxButtonComponent],
  templateUrl: './settings.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsComponent {
  protected readonly localizationService = inject(LocalizationService);
  private readonly translate = inject(TranslateService);

  protected readonly breadcrumbOptions = signal<BxBreadcrumb[]>([
    { label: this.translate.instant('navigation.settings'), route: '/settings' },
  ]);
}
